module.exports = __webpack_public_path__ + "img/icon-delivery.fe341c9a.svg";